// Naari Sutra Terms & Conditions — adapted from the CookSorted terms to cover the
// Naari Sutra website and all Naari products.
export const TERMS = {
  effective: "Effective Date: 1 July 2025",
  updated: "Last Updated: 1 July 2025",
  intro:
    'Welcome to Naari Sutra, operated by Naari Living Technologies LLP ("Company", "we", "our", or "us"), a Limited Liability Partnership registered under the Limited Liability Partnership Act, 2008, with its registered office at Flat No. 606, Block B, Vimal Shyam Vihar, Pundag, Ranchi, Jharkhand – 834004, India. By accessing or using the Naari Sutra website (naarisutra.in) or any of our products, including CookSorted, LookSorted, GlowSorted and HomeSorted (together, the "Services"), or by registering an account or joining a waitlist, you ("User", "you", or "your") agree to be bound by these Terms & Conditions ("Terms"). Please read them carefully before using the Services. If you do not agree to these Terms, please do not use the Services.',
  sections: [
    {
      title: "1. Eligibility",
      intro:
        "You must be at least 18 years of age to use the Services. By using the Services, you represent and warrant that:",
      items: [
        "You are at least 18 years old",
        "You have the legal capacity to enter into a binding agreement",
        "You are a resident of India or otherwise subject to Indian law",
        "Any information you provide is accurate, current, and complete",
      ],
      note: "We reserve the right to suspend or terminate your account if we have reason to believe you do not meet these eligibility requirements.",
    },
    {
      title: "2. Account Registration",
      intro:
        "To access certain features of the Services, you must register for an account. You agree to:",
      items: [
        "Provide accurate and complete registration information including your name, email address, and phone number",
        "Keep your login credentials confidential and not share them with any third party",
        "Notify us immediately of any unauthorised use of your account",
        "Be solely responsible for all activity that occurs under your account",
      ],
      note: "We reserve the right to refuse registration or cancel an account at our sole discretion.",
    },
    {
      title: "3. Services and Subscription",
      subsections: [
        {
          heading: "Free Tier",
          items: [
            "Our products may offer a free tier providing basic features at no charge. Access to free features is subject to availability and may change at our discretion.",
          ],
        },
        {
          heading: "Premium Subscription",
          intro: 'Certain features are available exclusively under a paid subscription plan ("Premium"). By subscribing, you agree to:',
          items: [
            "Pay the applicable subscription fees as displayed at the time of purchase",
            "Authorise us to charge your selected payment method on a recurring basis (monthly or annually, as applicable)",
            "Comply with the payment terms of our payment gateway partner (Razorpay / PayU / Stripe, as applicable)",
          ],
        },
        {
          heading: "Cancellation & Refunds",
          items: [
            "You may cancel your subscription at any time from within the App or your device's app store settings. Cancellation will take effect at the end of the current billing cycle. We do not offer pro-rated refunds for partial subscription periods, except where required under applicable Indian law.",
            "Refund requests related to technical issues or billing errors may be submitted to grievance.naarisutra@gmail.com and will be evaluated on a case-by-case basis within 15 business days.",
          ],
        },
        {
          heading: "Price Changes",
          items: [
            "We reserve the right to modify subscription pricing at any time. We will provide at least 30 days' prior notice of any price increase. Continued use of the Services after the effective date of a price change constitutes your acceptance of the new price.",
          ],
        },
      ],
    },
    {
      title: "4. Acceptable Use",
      intro:
        "You agree to use the Services only for lawful purposes and in accordance with these Terms. You must not:",
      items: [
        "Use the Services in any way that violates applicable Indian or local laws or regulations",
        "Transmit any material that is harmful, offensive, obscene, or otherwise objectionable",
        "Attempt to gain unauthorised access to any part of the Services or their related systems",
        "Reverse-engineer, decompile, disassemble, or otherwise attempt to derive the source code of the Services",
        "Upload or transmit viruses or any other malicious code",
        "Use automated tools (bots, scrapers, crawlers) to access or interact with the Services",
        "Impersonate any person or entity or misrepresent your affiliation with any person or entity",
        "Collect or harvest any personally identifiable information from the Services without consent",
      ],
      note: "We reserve the right to investigate and take appropriate legal action, including terminating your account, for any violation of these terms.",
    },
    {
      title: "5. Intellectual Property",
      body: [
        "All content, features, and functionality of the Services, including but not limited to text, graphics, logos, icons, images, and software, are the exclusive property of Naari Living Technologies LLP and are protected under the Copyright Act, 1957, the Trade Marks Act, 1999, and other applicable Indian intellectual property laws.",
        "You are granted a limited, non-exclusive, non-transferable, revocable licence to access and use the Services for personal, non-commercial purposes only. Nothing in these Terms transfers any intellectual property rights to you.",
        "The Naari Sutra name, product names (CookSorted, LookSorted, GlowSorted, HomeSorted), logos, and taglines are trademarks of Naari Living Technologies LLP. You may not use our trademarks without our prior written consent.",
      ],
    },
    {
      title: "6. User-Generated Content",
      body: [
        "If the Services permit you to submit, post, or share content (such as custom plans, reviews, or comments), you retain ownership of your content but grant us a worldwide, royalty-free, non-exclusive licence to use, reproduce, modify, adapt, and display such content for the purpose of operating and improving the Services.",
        "You represent and warrant that your content does not infringe any third-party rights and does not violate any applicable laws.",
        "We reserve the right to remove any content at our sole discretion without prior notice.",
      ],
    },
    {
      title: "7. Third-Party Services",
      intro: "The Services integrate with third-party services including:",
      items: [
        "Google (Sign-In, Analytics) — governed by Google's Terms of Service and Privacy Policy",
        "Razorpay / PayU / Stripe — payment processing governed by their respective terms",
        "Firebase Cloud Messaging / OneSignal — for push notifications",
      ],
      note: "We are not responsible for the availability, accuracy, or practices of these third-party services. Your use of third-party services is governed by their respective terms and privacy policies. We encourage you to review them.",
    },
    {
      title: "8. Disclaimers",
      body: [
        'The Services and their content are provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, express or implied, including but not limited to warranties of merchantability, fitness for a particular purpose, or non-infringement.',
        "Naari Sutra provides recommendations and suggestions only. Nothing in the Services constitutes nutritional, dietary, medical, styling, or professional advice. Always consult a qualified professional before making significant changes based on our recommendations.",
        "We do not guarantee that the Services will be uninterrupted, error-free, or free of viruses or other harmful components.",
      ],
    },
    {
      title: "9. Limitation of Liability",
      body: [
        "To the maximum extent permitted by applicable Indian law, Naari Living Technologies LLP and its partners, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of or inability to use the Services.",
        "Our total aggregate liability to you for any claim arising out of or relating to these Terms or the Services shall not exceed the amount you paid to us in the 3 months preceding the claim, or INR 500, whichever is greater.",
        "Nothing in these Terms limits liability that cannot be limited under applicable law, including liability for death or personal injury caused by our negligence or fraud.",
      ],
    },
    {
      title: "10. Indemnification",
      body: [
        "You agree to indemnify, defend, and hold harmless Naari Living Technologies LLP and its partners, officers, employees, and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, or expenses (including reasonable legal fees) arising out of your violation of these Terms or your use of the Services.",
      ],
    },
    {
      title: "11. Governing Law and Dispute Resolution",
      body: [
        "These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.",
        "Any dispute, controversy, or claim arising out of or relating to these Terms or the Services shall first be attempted to be resolved through good-faith negotiations. If unresolved within 30 days, the dispute shall be subject to the exclusive jurisdiction of the courts at Ranchi, Jharkhand, India.",
        "Nothing in this clause limits your rights under the Consumer Protection Act, 2019, including the right to approach consumer forums.",
      ],
    },
    {
      title: "12. Modifications to Terms",
      body: [
        'We reserve the right to modify these Terms at any time. We will notify you of material changes by sending an in-app or on-site notification or by posting the updated Terms with a revised "Last Updated" date.',
        "Your continued use of the Services after the effective date of any modification constitutes your acceptance of the updated Terms. If you do not agree to the updated Terms, you must stop using the Services.",
      ],
    },
    {
      title: "13. Termination",
      body: [
        "We may suspend or terminate your account and access to the Services at any time, with or without cause, and with or without notice. Upon termination, your right to use the Services will immediately cease.",
        "You may delete your account at any time via the App settings.",
        "Sections 5 (Intellectual Property), 8 (Disclaimers), 9 (Limitation of Liability), 10 (Indemnification), and 11 (Governing Law) shall survive termination.",
      ],
    },
    {
      title: "14. Grievance Redressal",
      intro:
        "In accordance with the Information Technology Act, 2000 and the Information Technology (Intermediary Guidelines and Digital Media Ethics Code) Rules, 2021, we have appointed a Grievance Officer:",
      items: [
        "Name: Ambalika Smiti",
        "Email: grievance.naarisutra@gmail.com",
        "Company: Naari Living Technologies LLP",
      ],
      note: "Grievances will be acknowledged within 48 hours and resolved within 30 days of receipt, in accordance with applicable law.",
    },
    {
      title: "15. Contact Us",
      body: [
        "If you have any questions about these Terms, please contact us at:",
        "Naari Living Technologies LLP",
        "Flat No. 606, Block B, Vimal Shyam Vihar, Pundag, Ranchi, Jharkhand – 834004, India",
        "grievance.naarisutra@gmail.com",
      ],
    },
  ],
};
